// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tourist-home-container p{font-size:12px;font-weight:300}.tourist-home-container strong{font-weight:500}", ""]);
// Exports
module.exports = exports;
